import { db } from "@/plugins/firebase";

export default () => {
  function getOnSnapshotSubscriptionFunction(onUpdate) {
    return snapshot => {
      const newData = [];

      snapshot.docs.forEach(doc => {
        const data = doc.data();
        newData.push({ id: doc.id, data: data });
      });
      onUpdate(newData);
    };
  }

  // A comma separated string of ballots
  // ballots: row[0]

  // Weights
  // weights: 1

  // SSN for the delegate
  // ssn: row[1]

  // Manually set name
  // manual-name: row[2]

  // Phone number
  // phone: row[3]

  // Email
  // email: row[4]
  return {
    meetingMembers: (meetingId, onUpdate) => {
      return db
        .collection("meetings")
        .doc(meetingId)
        .collection("members")
        .onSnapshot(getOnSnapshotSubscriptionFunction(onUpdate));
    },
    updateMember: async (meetingId, id, member) => {
      await db
        .collection("meetings")
        .doc(meetingId)
        .collection("members")
        .doc(id)
        .set(member, { merge: true });
    },
    deleteMember: async (meetingId, id) => {
      await db
        .collection("meetings")
        .doc(meetingId)
        .collection("members")
        .doc(id)
        .delete();
    }
  };
};
